<template>
    <div>
        <app-header></app-header>
        <app-description></app-description>
        <div class="container-fluid mt-3 mb-5">
            <div class="row">
                <div class="col-lg-10 offset-lg-1 col-xl-8 offset-xl-2">
                    <server-selection
                        @loggingMethodUpdated="loggingMethod = $event"></server-selection>
                    <div class="row">
                        <div class="col-lg-6">
                            <component
                                :is="serverFormComponent"
                                :serverData="serverData"
                                @serverAdded="addServer($event)"
                                @serverRemoved="removeServer($event)"></component>
                        </div>
                        <div class="col-lg-6">
                            <logger-details :loggerData="loggerData"></logger-details>
                        </div>
                    </div>
                    <polling-group
                        v-if="modbusConfig.pollingGroupArr.length > 0"
                        v-for="pollingGroup in modbusConfig.pollingGroupArr"
                        :key="pollingGroup.id"
                        :modbusConfig="modbusConfig"
                        :pollingGroup="pollingGroup"
                        :loggingMethod="loggingMethod"
                        @queryAdded="addQuery"
                        @tagAdded="addTag"
                        @pollingGroupRemoved="removePollingGroup($event)"
                        @queryRemoved="removeQuery($event)"
                        @tagRemoved="removeTag($event)"></polling-group>
                    <button
                        class="btn btn-outline-info btn-sm mt-3"
                        @click="addPollingGroup"
                        :disabled="modbusConfig.pollingGroupArr.length >= 6 ? true : false">+ Add Polling Group</button>
                </div>
            </div>
            <div class="row">
                <div class="col-lg-10 offset-lg-1 col-xl-8 offset-xl-2">
                    <upload-group
                        v-if="modbusConfig.uploadGroupArr.length > 0"
                        v-for="uploadGroup in modbusConfig.uploadGroupArr"
                        :key="uploadGroup.uploadGroupId"
                        :modbusConfig="modbusConfig"
                        :uploadGroup="uploadGroup"
                        @uploadGroupRemoved="removeUploadGroup($event)"
                        @statusReportingChanged="updateStatusReporting($event)"></upload-group>
                    <button
                        class="btn btn-outline-danger btn-sm mt-3"
                        @click="addUploadGroup"
                        :disabled="modbusConfig.uploadGroupArr.length >= 5 ? true : false">+ Add Upload Group</button>
                </div>
            </div>
            <div class="row mt-5">
                <div class="col-lg-4 offset-lg-4">
                    <button
                        class="btn btn-success mt-5 btn-block"
                        @mousedown="generateCsv">Generate CSV</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import AppHeader from '../header/AppHeader.vue'
import AppDescription from '../description/Description.vue'
import ServerSelection from '../server-forms/ServerSelection.vue'
import FtpDetails from '../server-forms/FtpDetails.vue'
import HttpDetails from '../server-forms/HttpDetails.vue'
import CumulocityDetails from '../server-forms/CumulocityDetails.vue'
import MqttDetails from '../server-forms/MqttDetails.vue'
import AzureDetails from '../server-forms/AzureDetails.vue'
import LoggerDetails from '../logger-details/LoggerDetails.vue'
import PollingGroup from '../polling-group/PollingGroup.vue'
import UploadGroup from '../upload-group/UploadGroup.vue'
import generateCsv from '../../generate-csv/generateCsv.js'

export default {
    components: {
        'app-header': AppHeader,
        'app-description': AppDescription,
        'server-selection': ServerSelection,
        'ftp-details': FtpDetails,
        'http-details': HttpDetails,
        'cumulocity-details': CumulocityDetails,
        'mqtt-details': MqttDetails,
        'azure-details': AzureDetails,
        'logger-details': LoggerDetails,
        'polling-group': PollingGroup,
        'upload-group': UploadGroup
    },
    data() {
        return {
            loggingMethod: 'ftp',
            serverData: {
                ftp: {
                    serverArr: []
                },
                http: {
                    serverArr: []
                },
                cumulocity: {
                    serverUrl: 'NULL',
                    emailLogin: 'NULL',
                    password: 'NULL',
                    ftpServerAddress: 'NULL',
                    ftpPortNumber: 'NULL',
                    ftpUsername: 'NULL',
                    ftpPassword: 'NULL',
                    ftpConfigFilePath: 'NULL'
                },
                mqtt: {
                    hostname: 'NULL',
                    portNumber: 'NULL',
                    username: 'NULL',
                    password: 'NULL',
                    topicName: 'NULL',
                    qos: '0',
                    ftpServerAddress: 'NULL',
                    ftpPortNumber: 'NULL',
                    ftpUsername: 'NULL',
                    ftpPassword: 'NULL',
                    ftpConfigFilePath: 'NULL',
                    senddatamode: '0',
                    jsondataview: '2'
                },
                azure: {
                    hostname: 'NULL',
                    portNumber: 'NULL',
                    deviceid: 'NULL',
                    shpolicyname: 'NULL',
                    shpolicykey: 'NULL',
                    tokentime: 'NULL',
                    topicName: 'NULL',
                    qos: '0',
                    ftpServerAddress: 'NULL',
                    ftpPortNumber: 'NULL',
                    ftpUsername: 'NULL',
                    ftpPassword: 'NULL',
                    ftpConfigFilePath: 'NULL',
                    senddatamode: '0',
                    jsondataview: '2'
                }
            },
            loggerData: {
                loggerId: 'NULL',
                databaseSize: '10240',
                rtuTimeout: '1000',
                tcpTimeout: '1000',
                tcpStatus: '0',
                tcpPort: '12345'
            },
            modbusConfig: {
                pollingGroupArr: [],
                uploadGroupArr: []
            },
            ftpServerIdStore: 0,
            httpServerIdStore: 0,
            pollingGroupIdStore: 0,
            queryIdStore: 0,
            tagIdStore: 0,
            uploadGroupIdStore: 0
        }
    },
    computed: {
        serverFormComponent() {
            if(this.loggingMethod === 'ftp') {
                return 'ftp-details'
            } else if(this.loggingMethod === 'http') {
                return 'http-details'
            } else if(this.loggingMethod === 'cumulocity') {
                return 'cumulocity-details'
            } else if(this.loggingMethod === 'mqtt') {
                return 'mqtt-details'
            } else if(this.loggingMethod === 'azure') {
                return 'azure-details'
            }
        }
    },
    mounted() {
        this.addServer('ftp')
        this.addServer('http')
    },
    methods: {
        addServer(serverType) {
            this[serverType + 'ServerIdStore']++
            this.serverData[serverType].serverArr.push({
                serverId: this[serverType + 'ServerIdStore'],
                serverAddress: 'NULL',
                portNumber: 'NULL',
                username: 'NULL',
                password: 'NULL',
                dataLoggingPath: 'NULL',
                errorLoggingPath: 'NULL',
                configFilePath: 'NULL',
                ftpserverAddress: 'NULL',
                ftpportNumber: 'NULL',
                ftpusername: 'NULL',
                ftppassword: 'NULL',
                senddatamode: '0',
                jsondataview: '2'
            })
        },
        removeServer($event) {
            let selectedServerIndex = this.serverData[$event.serverType].serverArr.findIndex((el) => {
                return el.serverId === $event.serverId
            })
            this.serverData[$event.serverType].serverArr.splice(selectedServerIndex, 1)
        },
        addPollingGroup() {
            this.pollingGroupIdStore++
            this.modbusConfig.pollingGroupArr.push({
                pollingGroupId: this.pollingGroupIdStore,
                pollingInterval: '',
                logType: '0',
                gpsReportingState: '0',
                lanReportingState: '0',
                wanReportingState: '0',
                cellularReportingState: '0',
                generalReportingState: '0',
                queryArr: []
            })
        },
        addQuery(pollingGroupId) {
            this.queryIdStore++
            let selectedPollingGroupArrIndex = this.modbusConfig.pollingGroupArr.findIndex((el) => {
                return el.pollingGroupId === pollingGroupId
            })
            this.modbusConfig.pollingGroupArr[selectedPollingGroupArrIndex].queryArr.push({
                queryId: this.queryIdStore,
                queryName: '',
                slaveId: '',
                functionCode: '',
                startAddress: '',
                numberOfRegisters: '',
                ipAddress: 'NULL',
                port: 'NULL',
                tagArr: []
            })
        },
        addTag(pollingGroupId, selectedQueryArrIndex) {
            this.tagIdStore++
            let selectedPollingGroupArrIndex = this.modbusConfig.pollingGroupArr.findIndex((el) => {
                return el.pollingGroupId === pollingGroupId
            })
            this.modbusConfig.pollingGroupArr[selectedPollingGroupArrIndex].queryArr[selectedQueryArrIndex].tagArr.push({
                tagId: this.tagIdStore,
                tagName: '',
                tagAddressOffset: '',
                tagAddressLength: '',
                tagDatatype: '',
                tagLinearScalingCoefficientA: '1',
                tagLinearScalingOffsetB: '0',
                tagAlertFlag: '4',
                tagMinimumThreshold: 'NULL',
                tagMaximumThreshold: 'NULL',
                tagMobileNumber: 'NULL',
                tagCriticalTag: '0',
                tagCriticalAlarm: '0',
                tagStoreAsFloat: '0',
                tagUnitOfMeasurement: 'NULL'
            })
        },
        addUploadGroup() {
            this.uploadGroupIdStore++
            this.modbusConfig.uploadGroupArr.push({
                uploadGroupId: this.uploadGroupIdStore,
                uploadInterval: '',
                selectedTagArr: [],
                statusReportingEnabledArr: ['0', '0', '0', '0', '0', '0']
            })
        },
        removePollingGroup($event) {
            let selectedPollingGroupIndex = this.modbusConfig.pollingGroupArr.findIndex((el) => {
                return el.pollingGroupId === $event.pollingGroupId
            })

            this.modbusConfig.pollingGroupArr.splice(selectedPollingGroupIndex, 1)
        },
        removeQuery($event) {
            let selectedPollingGroupIndex = this.modbusConfig.pollingGroupArr.findIndex((el) => {
                return el.pollingGroupId === $event.pollingGroupId
            })
            let selectedQueryIndex = this.modbusConfig.pollingGroupArr[selectedPollingGroupIndex].queryArr.findIndex((el) => {
                return el.queryId === $event.queryId
            })

            this.modbusConfig.pollingGroupArr[selectedPollingGroupIndex].queryArr.splice(selectedQueryIndex, 1)
        },
        removeTag($event) {
            let selectedPollingGroupIndex = this.modbusConfig.pollingGroupArr.findIndex((el) => {
                return el.pollingGroupId === $event.pollingGroupId
            })

            let selectedQueryIndex = this.modbusConfig.pollingGroupArr[selectedPollingGroupIndex].queryArr.findIndex((el) => {
                return el.queryId === $event.queryId
            })

            let selectedTagIndex = this.modbusConfig.pollingGroupArr[selectedPollingGroupIndex].queryArr[selectedQueryIndex].tagArr.findIndex((el) => {
                return el.tagId === $event.tagId
            })

            this.modbusConfig.pollingGroupArr[selectedPollingGroupIndex].queryArr[selectedQueryIndex].tagArr.splice(selectedTagIndex, 1)
        },
        removeUploadGroup($event) {
            let selectedUploadGroupIndex = this.modbusConfig.uploadGroupArr.findIndex((el) => {
                return el.uploadGroupId === $event.uploadGroupId
            })

            this.modbusConfig.uploadGroupArr.splice(selectedUploadGroupIndex, 1)
        },
        updateStatusReporting($event) {
            let selectedUploadGroupIndex = this.modbusConfig.uploadGroupArr.findIndex((el) => {
                return el.uploadGroupId === $event.uploadGroupId
            })

            let selectedPollingGroupIndex = this.modbusConfig.pollingGroupArr.findIndex((el) => {
                return el.pollingGroupId === $event.pollingGroupId
            })

            this.modbusConfig.uploadGroupArr[selectedUploadGroupIndex].statusReportingEnabledArr[selectedPollingGroupIndex] = $event.value
        },
        generateCsv() {
            generateCsv(this)
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/modbus-config-app/ModbusConfigApp.vue